module.exports = __webpack_public_path__ + "img/left_5_hover.6b5d88f2.png";